//管理员导航菜单
export default [
    {label:'订单管理',iconClass:'icon-dingdan1',powerArr:[221,261,365,433,431,138,107,546],num:'confirming_order_arr',  
            children:[
            {label:'待审核', iconClass:'icon-shenpizhong', powerArr:[79,222],path:{name:'OrderHandle',query:{page:1,orderStatus:'0',orderType:3}},num:'examine'},
            {label:'待确认',path:{name:'OrderConfirmed',query:{page:1,orderStatus:'1',orderType:3}},num:'confirming_order_arr'},
            {label:'询价中',powerArr:[79,222],path:{name:'Quotation',query:{page:1,orderStatus:'1',orderType:99}},num:'status_4'},
            // {label:'询价中', iconClass:'icon-shenpizhong', powerArr:[79,222],path:{name:'OrderHandle',query:{page:1,orderStatus:'0',orderType:3}},num:'examine'},
            {label:'订单列表',powerArr:[221,261,365,433,431,138,107,546],path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'order'},
        ],
    },
    {label:'运营管理',iconClass:'icon-yunyingguanli',powerArr:[101],path:{name:'OperationManage'}},
    // {label:'集团管理',iconClass:'icon-jituanqiye',powerArr:[92],path:{name:'GroupManage',query:{tab: '3'}}},
    {label:'关联申请',
        iconClass:'icon-shenheguanli',
        path:{name:'PersonnelList'},
        num:'unionRecord_count'
    },
    {label:'审核管理',
        iconClass:'icon-shenhe',
        num:'manage',
        children:[
            {label:'注册认证',powerArr:[135,136,424,48,47],path:{name:'VerifyStore',query:{page:1}},num:'register'},
            {label:'编辑认证',powerArr:[135,136,424,48,47],path:{name:'VerifyStoreCheck',query:{page:1}},num:'nize'},
            {label:'银行卡认证',powerArr:[135,136,424,48,47],path:{name:'BankcardManage',query:{page:1}},num:'bankcard_count'},
        ]
    },
    {label:'用户管理',
        iconClass:'icon-yonghuguanli',
        num:'room',
        powerArr:[79],
        children:[
            {label:'酒店销售',powerArr:[50],path:{name:'UserManage',query:{storeType:3,type:3,page:1,level:3}}},
            {label:'采购人员',powerArr:[97],path:{name:'UserManage',query:{storeType:1,type:2,page:1,level:3}}},
            {label:'个人用户',powerArr:[50],path:{name:'UserManage',query:{storeType:2,type:2,page:1,level:4}}},
            {label:'导游用户',powerArr:[51],path:{name:'SalespersonList'}},
        ],
    },
    {label:'企业管理',
        iconClass:'icon-jiudian',
        num:'room',
        children:[
            {label:'供应商',powerArr:[50],path:{name:'StoreManage',query:{storeType:3,page:1}},num:'room'},
            {label:'采购商',powerArr:[97],path:{name:'StoreManage',query:{storeType:2,page:1}}},
            // {label:'导游列表',powerArr:[97],path:{name:'StoreManage',query:{storeType:4,page:1}}},
        ],
    },
    {label:'提现管理',
        iconClass:'icon-tixian',
        children:[
            {label:'采购商利润',powerArr:[60],path:{name:'WithdrawApply'},num:'withdraw_count'},
            {label:'供应商团款',powerArr:[60],path:{name:'WithdrawHotel'}},
        ],
    },
    {label:'财务管理',
        iconClass:'icon-caiwuguanli',
        num:'treasurer_count',
        children:[
            // {label:'发票申请',powerArr:[40],path:{name:'InvoiceApply'}},
            {label:'待付款',powerArr:[60],path:{name:'PaymentList'},num:'payment_count'},
            {label:'已付款',powerArr:[60],path:{name:'PaymentRecordList'}},
            {label:'系统收款',powerArr:[66],path:{name:'IncomeList'}},
            {label:'系统退款',powerArr:[66],path:{name:'RefundList'}},
            {label:'数据统计',powerArr:[66],path:{name:'FinancialStats'}},
        ],
    },
    {label:'权限管理',
        iconClass:'icon-xitongquanxian',
        children:[
            {label:'权限节点',powerArr:[77],path:{name:'AccessNode'}},
            {label:'职位管理',powerArr:[69],path:{name:'PositionManage'}},
            {label:'管理员管理',powerArr:[113],path:{name:'AdminManage'}},
        ],
    },
]
